import * as React from "react"
import * as ReactDom from "react-dom"

import View from "../views/estadio"
import { prefetchImages } from "../../utils/prefetchImages"


ReactDom.render(<View /> , document.getElementById('app'))

export const page = async () => {
  sessionStorage.setItem('soundMuted', 'true')
	require('../js/estadio.js').init()
	
	window.addEventListener(
    "touchmove",
    (e) => {
      e.preventDefault();
    },
    { passive: false }
  );

  setTimeout(() => {
    prefetchImages();
  }, 5000);
}


